// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"732":"38113720","977":"d28c2fc7"}[chunkId] + ".chunk.js";
};